import core from './core';

export default {
  create({ status, sim_id, flight_id, type, identity_no, phone, vendor_agent_id, agency, note, provision_date, agree_to_join, images, signature }) {
    return core.postFormData('/applications', {
      status, sim_id, flight_id, type, identity_no, phone, vendor_agent_id, agency, note, provision_date, agree_to_join, images, signature
    });
  },

  get({ search, sort, direction, status, type, sim_id, flight_id, identity_no, phone, vendor_agent_id, agency, between_created_at, withData } = {}) {
    return core.get('applications', {
      params: {
        search, sort, direction, status, type, sim_id, flight_id, identity_no, phone, vendor_agent_id, agency, 'between:created_at': between_created_at, 'with': withData
      }
    });
  },

  update(id, { status, sim_id, flight_id, type, identity_no, phone, vendor_agent_id, agency, note, provision_date, agree_to_join, images, signature, batch }) {
    return core.postFormData(`applications/${id}`,{
      status, sim_id, flight_id, type, identity_no, phone, vendor_agent_id, agency, note, provision_date, agree_to_join, images, signature, batch
    });
  },

  fetch(id) {
    return core.get(`applications/${id}`);
  },

  fetchReSign(hash) {
    return core.get(`re-sign/${hash}`);
  },

  reSign(hash, { signature }) {
    return core.postFormData(`re-sign/${hash}`,{
      signature
    });
  },

  delete(id) {
    return core.delete(`applications/${id}`);
  },

  uploadImages(id, images) {
    return core.postFormData(`applications/${id}/images`, {
      images
    });
  },

  deleteImage(id, imageId) {
    return core.delete(`applications/${id}/images/${imageId}`);
  },
}
